import { clsx } from 'clsx';

interface NumberStepProps {
  className?: string;
  number: number;
  children?: React.ReactNode;
}

export function NumberStep({
  className,
  number,
  children,
}: NumberStepProps): JSX.Element {
  return (
    <h4 className="flex items-center">
      <div
        className={clsx(
          'flex h-6 w-6 items-center justify-center rounded-full bg-black text-sm text-white',
          className,
        )}
      >
        {number}
      </div>
      <span className="ml-4">{children}</span>
    </h4>
  );
}
